module.exports = {
  // docker: {
  //   urlBase: 'http://localhost:3000/',
  //   urlApi: 'http://localhost:8000/api',
  // },
  local: {
    urlBase: 'http://localhost:3001/',
    urlApi: 'http://localhost:5001/back',
    urlApiNext: 'http://localhost:3001/api', // back-end of nextjs, for testing purpose
    urlWebSocket: 'http://localhost:5001', // direct backend — no proxy locally
  },
  // Aperçu de revue apptidesk : tout est servi sur UNE origine, celle du proxy,
  // qui n'est connue qu'au montage. D'où des URLs relatives : le navigateur les
  // résout contre la page qu'il a chargée, donc contre la bonne origine, et le
  // bundle compilé ne porte aucun port. C'est ce qui permet de compiler une
  // fois et de servir n'importe quel aperçu.
  preview: {
    urlBase: '/',
    urlApi: '/back',
    urlApiNext: '/api',
    urlWebSocket: '', // même origine : socket.io résout contre la page
  },
  dev: {
    urlBase: 'https://spacetalk-dev.appti.ch',
    urlApi: 'https://spacetalk-dev.appti.ch/back',
    urlApiNext: 'https://spacetalk-dev.appti.ch/api',
    urlWebSocket: 'https://spacetalk-dev.appti.ch', // Traefik routes /socket.io → backend
  },
  uat: {
    urlBase: 'https://spacetalk-uat.appti.ch',
    urlApi: 'https://spacetalk-uat.appti.ch/back',
    urlApiNext: 'https://spacetalk-uat.appti.ch/api',
    urlWebSocket: 'https://spacetalk-uat.appti.ch', // Traefik routes /socket.io → backend
  },
  int: {
    urlBase: 'https://spacetalk-int.appti.ch',
    urlApi: 'https://spacetalk-int.appti.ch/back',
    urlApiNext: 'https://spacetalk-int.appti.ch/api',
  },
  prd: {
    urlBase: 'https://app.spacetalk.ch',
    urlApi: 'https://app.spacetalk.ch/back',
    urlApiNext: 'https://app.spacetalk.ch/api',
    urlWebSocket: 'https://app.spacetalk.ch', // Traefik routes /socket.io → backend
  },
};
